import './DataCard.scss';
import { CSSProperties } from 'react';

interface DataCardProps {
  label: string;
  value: string | number;
  width?: CSSProperties['width'];
}

export const DataCard = ({ label, value, width }: DataCardProps) => (
  <div className='data-card' style={{ width }}>
    <div className='data-card-title'>{label}</div>
    <div className='data-card-value'>{value}</div>
  </div>
);
